import {
  FETCH_AUDIT_LOGS_REQUEST,
  FETCH_AUDIT_LOGS_SUCCESS,
  FETCH_AUDIT_LOGS_FAILURE,
} from "../Types";

const initialState = {
  loading: false,
  auditLogs: [],
  error: null,
};

const JournalAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUDIT_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        auditLogs: action.payload,
      };

    case FETCH_AUDIT_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default JournalAuditReducer;
